import { getUserDisplayName } from 'owa-session-store';
import type bookingDashboard from '../store/schema/BookingDashboard';
import {
    bookWithMePageBannerTitle,
    bookWithMePageBannerSummary,
} from '../components/read/ReadSessions.locstring.json';
import loc from 'owa-localize';
import { defaultBanner } from './defaultBanner';

export default function initBookingDashboard(): bookingDashboard {
    const bookingInfo: bookingDashboard = {
        title: getUserDisplayName() ?? '',
        titleWithPage: getUserDisplayName() + ' - ' + loc(bookWithMePageBannerTitle),
        about: loc(bookWithMePageBannerSummary),
        themeImage: defaultBanner(),
    };
    return bookingInfo;
}
